import { render, staticRenderFns } from "./CfgGrupos.vue?vue&type=template&id=49643785&scoped=true"
import script from "./CfgGrupos.vue?vue&type=script&lang=js"
export * from "./CfgGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49643785",
  null
  
)

export default component.exports